import ImageOffCanvas from '../OffCanvas/ImageOffCanvas/ImageOffCanvas';

function Image({
  show,
  imgSrc,
  preview,
  isVisible,
  //
  handleSave,
  handleShow,
  handleClose
}) {
  return (
    <>
      <div onClick={() => !preview && handleShow()}>
        {imgSrc ? (
          <img
            src={imgSrc}
            alt="logo"
            style={{
              width: '160px',
              height: '160px',
              objectFit: 'contain'
            }}
          />
        ) : preview ? null : (
          <span className={`${isVisible ? '' : 'hidden'} hidden-in-print`}>
            <button className="btn btn-primary">Click to upload Image</button>
          </span>
        )}
      </div>
      <ImageOffCanvas
        title="Right Logo"
        show={show}
        handleSave={handleSave}
        handleClose={handleClose}
      />
    </>
  );
}

export default Image;
